"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _base = _interopRequireDefault(require("../../style/themes/base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const StyledInput = _styledComponents.default.input`
  background: transparent;
  border: none;
  color: ${({
  theme
}) => theme.text.color};
  flex-grow: 1;
  font-size: ${({
  theme
}) => theme.text.size};
  outline: none;
  padding: 0;
  margin: 0;
  width: 30px;

  &:-webkit-autofill {
    box-shadow: 0 0 0px 1000px #fff inset;
    -webkit-box-shadow: 0 0 0px 1000px #fff inset;
    -webkit-box-border: none;
  }

  ${({
  align
}) => align && (0, _styledComponents.css)`
      text-align: ${align};
    `}

  &::placeholder {
    color: ${({
  theme
}) => theme.text.placeholder};
  }

  ${({
  disabled,
  theme
}) => disabled && (0, _styledComponents.css)`
      color: ${theme.disabled.disabled};
      cursor: not-allowed;
    `}

  &:invalid, &:required {
    box-shadow: 0 0 0px 1000px #fff inset;
    -webkit-box-shadow: 0 0 0px 1000px #fff inset;
  }

  ${({
  readOnly,
  theme
}) => readOnly && (0, _styledComponents.css)`
      color: ${theme.readOnly.textboxText};
    `}
`;
StyledInput.defaultProps = {
  theme: _base.default
};
StyledInput.propTypes = {
  disabled: _propTypes.default.bool
};
var _default = StyledInput;
exports.default = _default;